module.exports = __webpack_public_path__ + "img/living.88d438d5.gif";